import { useEffect, useState } from "react"
import References from "../../helpers/Reference";
import { extractUUIDSFromHolders, getHolderChildrens, loadPrecipitationHolders } from "./utils";
import { Button, Checkbox, DatePicker, Flex, Select } from "antd";

import dayjs from 'dayjs'
import locale from "antd/es/date-picker/locale/ru_RU"
import { convertBlobFrom64, saveFileDirectly } from "../../helpers/helpers";
import AuthService from "../../helpers/auth";

const REPORT_TYPE_ITEMS = [
    {
        label: "Excel",
        value: "xlsx"
    },
    {
        label: "PDF",
        value: "pdf"
    }
]

export const ReportDayPrecipitation = ({onStartReport, onFinishReport}) => {

    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)    

    const [holders, setHolders] = useState({})
    const [holdersSelect, setHoldersSelect] = useState([])

    const [reportType, setReportType] = useState(REPORT_TYPE_ITEMS[0].value)
    const [date, setDate] = useState(dayjs().subtract(1, 'day').startOf('day'))    


    useEffect(() => {
        loadPrecipitationHolders()
        .then(data => {
            setHolders(data)
            setHoldersSelect(extractUUIDSFromHolders(data))
        })
    }, []);

    const onReport = () => {

        setLoading(true)
        setDisabled(true)
        onStartReport()

        const req = {
            "report_type": "precipitation",
            "report_date": dayjs(date, References.dateTimeFormat).format(),
            "data_format": reportType,
            "holders": holdersSelect,            
        }
        AuthService.post(References.api.report_precipitation, req)
        .then(res => res.json())
        .then(data => saveFileDirectly(data.file_name, convertBlobFrom64(data.content_b64)))
        .catch(e => console.log(e.message))                    
        .finally(() => {
            setLoading(false)
            setDisabled(false)            
            onFinishReport()
        })
    }

    const onReportTypeSelect = ( item ) => {
        setReportType(item)
    }

    const onChangeDate = (date) => {
        setDate(date)
    }

    const onChangeHolders = (uuid) => {
        const childrens = getHolderChildrens(holders, uuid)                                
        setHoldersSelect(prev => {
            if (prev.includes(uuid)) {
                return (                    
                    prev.filter(id => id !== uuid && !childrens.includes(id))
                )
            } else {
                return (
                    [...prev, uuid, ...childrens]
                )
            }
        });
    }

    const onSelectAll = () => {
        setHoldersSelect(extractUUIDSFromHolders(holders))
    }

    const onResetAll = () => {
        setHoldersSelect([])
    }

    return (
        <>
            <div className="mt-2">
                <Flex>
                    <div className="w-50">
                        <Button className="w-100" onClick={onSelectAll} disabled={loading}>Выбрать все</Button>
                    </div>
                    <div className="w-50 ml-2">
                        <Button className="w-100" onClick={onResetAll} disabled={loading}>Сбросить все</Button>
                    </div>

                </Flex>
            </div>
            <div className="mt-2" style={{maxHeight: 300, overflowY: "auto"}}>
            {Object.keys(holders).map(uuid => {return (
                <div key={`report-precipitation-holder-${uuid}`} className="mt-2">
                    <div>
                        <Checkbox 
                            checked={holdersSelect.indexOf(uuid) > -1}
                            onChange={() => onChangeHolders(uuid)}
                            disabled={loading}
                        >
                            {holders[uuid].name}                            
                        </Checkbox>                        
                    </div>
                    {holders[uuid]?.children &&
                        <>
                            {holders[uuid].children.map(child => {
                                const childUUID = Object.keys(child)[0]
                                return (
                                    <div key={`report-precipitation-holder-${childUUID}`} className="mt-2 ml-2">
                                        <Checkbox 
                                            checked={holdersSelect.indexOf(childUUID) > -1}
                                            onChange={() => onChangeHolders(childUUID)}                                            
                                            disabled={loading}
                                        >
                                            {child[childUUID].name}                                            
                                        </Checkbox>
                                    </div>
                                )
                            })}    
                        </>
                    }
                </div>
            )})}                
            </div>

            <div className="mt-2">
            <Flex className="w-100">
                    <Select 
                        options={REPORT_TYPE_ITEMS}
                        value={reportType}
                        onChange={onReportTypeSelect}
                        className="w-50"
                        disabled={loading}
                    />
                    <DatePicker
                        defaultValue={dayjs(date, References.dateFormat)}                
                        onChange={onChangeDate}
                        onOk={onChangeDate}
                        format={"DD.MM.YYYY"}
                        locale={locale}
                        changeOnBlur
                        inputReadOnly
                        allowClear={false}
                        className="w-50 ml-2"
                        disabled={loading}
                    />                
                </Flex>
            </div>

            <div className="mt-2">
                <Button onClick={onReport} style={{width: "100%"}} type="primary" loading={loading} disabled={disabled || holdersSelect.length === 0}>Выполнить</Button>
            </div>

        </>
    )

}